import React from 'react';
import { Card, Button } from 'react-bootstrap';

const CSS = () => (
    <div className="card-grid">
        <Card>
            <Card.Img className="card-img" variant="top" src="/images/Techdegree-project-2-screenshot.png" />
            <Card.Body>
                <Card.Title>Responsive Website</Card.Title>
                <Card.Text>
                This project was my first attempt at using CSS to create a responsive webpage. 
                The only skills required to do this project was HTML and CSS. With the use of 
                media queries I was able to successfully build a responsive website that looked 
                similar to the template that was provided for this project.
                </Card.Text>
                <Button href="https://ramces14.github.io/Project2/" id="project-2-position" target="_blank">Enter</Button>
            </Card.Body>
        </Card>
        <Card>
            <Card.Img className="card-img" variant="top" src="/images/Techdegree-project-3-screenshot.png" />
            <Card.Body>
                <Card.Title>CSS Form</Card.Title>
                <Card.Text>
                The goal of this project was to create a responsive webpage with the main focus on forms. 
                Knowing how to create forms is an important part of web development and it allows people 
                to provide feedback or interaction with one another. Here once again used CSS and HTML to 
                create this responsive form using the template provided as a guide.
                </Card.Text>
                <Button href="https://ramces14.github.io/Techdegree-project-3/" target="_blank">Enter</Button>
            </Card.Body>
        </Card>
        <Card>
            <Card.Img className="card-img" variant="top" src="/images/Techdegree-project-4-screenshot.png" />
            <Card.Body>
                <Card.Title>SCSS Project</Card.Title>
                <Card.Text>
                        The goal of this project was to use SCSS and the many features that it comes with to 
                    edit the layout of this site. Overall I find SCSS as a better way to organize CSS files, 
                    similar to the way that React organizes components together. I still use SCSS sometimes to
                    organize the styles of very big projects, but for smaller project I stick to CSS.
                </Card.Text>
                <Button href="https://ramces14.github.io/techdegree-project-4/" target="_blank">Enter</Button>
            </Card.Body>
        </Card>
    </div>
);

export default CSS;